import RentInfo from './components/RentInfo';
import { LayoutWrapper } from './styles';

const RentInfoPage = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <LayoutWrapper>
        <RentInfo />
      </LayoutWrapper>
    </div>
  );
};

export default RentInfoPage;
